import { createContext } from "react";

export const TouchesContext = createContext();